import { render } from "./UploadPlaceholder.vue?vue&type=template&id=49cc89b9&scoped=true"
import script from "./UploadPlaceholder.vue?vue&type=script&lang=js"
export * from "./UploadPlaceholder.vue?vue&type=script&lang=js"

import "./UploadPlaceholder.vue?vue&type=style&index=0&id=49cc89b9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cc89b9"]])

export default __exports__